export const ScheduleTask = [
  //定时任务
  {
    path: "/scheduledTask",
    name: "scheduledTasks",
    component: () => import("@/views/scheduledTasks/index.vue"),
    children: [
      {
        name: "scheduledTasksInfo",
        path: "",
        redirect: "scheduledTasksInfo",
      },
      {
        path: "scheduledTasksInfo",
        component: () =>
          import("@/views/scheduledTasks/scheduledTasksInfo/index.vue"),
      },
    ],
  },
];
